import { PieChart } from '@/common/dashboard/charts/PieChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { TreeUtils } from '@/common/utils/TreeUtils';
import { useEffect, useState } from 'react';

// Highcharts puts the point name in its own header, so that is suppressed and the name is redrawn with the slice
// colour after it, leaving the count and the percentages from the plugin as plain lines beneath
const tooltipOptions = {
  headerFormat: '',
  pointFormatter: function () {
    let tooltip = `<span style="font-size: 0.8em">${this.name}</span> <span style="color:${this.color}">●</span><br/>`;
    tooltip += `Current Count: <b>${this.y}</b><br/>`;
    if (this.original.tooltipHtml) {
      tooltip += this.original.tooltipHtml;
    }
    return tooltip;
  },
};

export const DirSaleValChart = ({ formValues, totalProdIds, periodCode }) => {
  const { navigateTo } = useNavState();
  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    if (!formValues?.invPeriodId) {
      return;
    }

    const prodFilter = TreeUtils.smallestIdFilter(formValues.prodIds, totalProdIds);

    const reqParam = {
      invPeriodId: formValues.invPeriodId,
      prodIds: prodFilter.ids,
      prodIdsNot: prodFilter.not,
    };

    rsrc.data('sc', 'DIR_SALE_VAL_CHART_DATA_PLUGIN', reqParam).then((res) => {
      setData(res);
    });
  }, [formValues?.invPeriodId, formValues?.prodIds, totalProdIds]);

  const navigateToDirSaleLineList = (dataPoint) => {
    const prodExpr =
      formValues.prodIds?.length ?
        ExprUtils.or(ExprUtils.notExists('prodId'), ExprUtils.setExpr('prodId', formValues.prodIds))
      : ExprUtils.notExists('prodId');

    // A Direct Sale Line carries the Quarter it falls in, so a Month is drilled into on the invoice date
    const periodExpr =
      formValues.periodicity === 'MONTH' && periodCode ?
        ExprUtils.effectiveDateClause(
          'invDate',
          Number(periodCode.replace('M', '') + '01'),
          Number(periodCode.replace('M', '') + '31'),
        )
      : ExprUtils.whereParams('invPeriodId', formValues.invPeriodId);

    let expr = ExprUtils.and(periodExpr, prodExpr);

    const validationExpr =
      dataPoint.label === 'VALID' ?
        ExprUtils.whereParams('valStatus', 'VALID')
      : ExprUtils.contains('valRes', dataPoint.label);

    expr = ExprUtils.and(expr, validationExpr);

    navigateTo('/sc/dir-sale-line', {
      mode: Mode.LIST,
      expr,
    });
  };

  if (!data || data.length === 0) return;

  return (
    <PieChart
      data={data}
      tooltipOptions={tooltipOptions}
      onClick={(dataPoint) => navigateToDirSaleLineList(dataPoint)}
    />
  );
};
